import { lazyLoad } from 'utils/loadable';

export const SalesReportLoadable = lazyLoad(
  () => import('./SalesReportWrapper'),
  module => module.SalesReportWrapper,
);
